import React, { useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import * as Fa from "react-icons/fa";
import { Checkbox } from "primereact/checkbox";
import { RadioButton } from "primereact/radiobutton";
import { useState } from "react";
import { Calendar } from "primereact/calendar";
import Axios from "../../../api/Axios";
import storage from "../../../Services/Storage";
import { toast } from "react-toastify";
import { downloadExcel } from "../../../Services/GlobalFunc/downloadExcel";
import { GetDateFormat } from "../../../Services/GlobalFunc/DateFormat";
import { format } from "date-fns";

const typecategories = [
    { name: "Pack", key: "P" },
    { name: "Case", key: "C" },
    { name: "Ltr", key: "L" },
    { name: "Product Value", key: "PV" },
];
const distcategories = [
    { name: "Sales Executive", key: "SE" },
    { name: "Sales Manager", key: "SM" },
];
const geographycategories = [
    // { name: "Region", key: "R" },
    { name: "State", key: "S" },
    { name: "District", key: "D" },
    { name: "Town", key: "T" },
];
const customercategories = [
    { name: "Market", key: "M" },
    { name: "Sector", key: "S" },
    { name: "Sub Sector", key: "SS" },
    { name: "Sub Sector Detail", key: "SSD" },
    { name: "Channel", key: "CH" },
    { name: "Customer", key: "CU" },
];
const productcategories = [
    { name: "Master Brand", key: "MB" },
    { name: "Product Brand", key: "PB" },
    { name: "Product Brand Variant", key: "PBV" },
    { name: "Product Type", key: "PT" },
    { name: "Product Sub Type", key: "PST" },
    { name: "Product Variant", key: "PV" },
    { name: "Product", key: "PR" },
    { name: "Base Pack", key: "BP" },
    { name: "Market Space", key: "MS" },
    { name: "LBM Brand", key: "LBMB" },
];
//Download Format
const downloadFormat = [
    { name: "Horizontal", key: "H", val: "Y" },
    { name: "Vertical", key: "V", val: "Y" },
];
//Select Type
const freecategory = [
    { name: "Include Free", key: "IF", val: "Y" },
    { name: "Show Only Free", key: "SF", val: "Y" },
];
//File Type
const downloadfiletypes = [
    { name: "Export Data as xlsx", key: "xlsx" },
    { name: "Export Data as csv", key: "csv" },
];

const SalesCastrolQuarterly = () => {
    const auth = storage.getLocal("user");

    const [selectedTypesCategories, setSelectedTypesCategories] = useState([
        typecategories[2],
    ]);
    const [selectedGeogCateg, setSelectedGeogCateg] = useState([]);
    const [selectedDistCateg, setSelectedDistCateg] = useState([]);
    const [selectedcustCateg, setSelectedcustCateg] = useState([]);
    const [selectedprodCateg, setSelectedprodCateg] = useState([]);
    const [downloadformatCategory, setDownloadformatCategory] = useState(
        downloadFormat[0]
    );
    const [freecategories, setFreecategories] = useState(freecategory[0]);
    const [selectedfiletype, setSelectedfiletype] = useState(
        downloadfiletypes[0]
    );
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();
    const [fromyear, setFromYear] = useState(()=>{
        let date = new Date();
        date.setFullYear(date.getFullYear() - 2);
        return date;
    });
    const [toyear, setToYear] = useState(new Date());
    const [selectedFromDate, setSelectedFromDate] = useState();
    const [selectedtoDate, setSelectedToDate] = useState();
    const [loadingExcel, setLoadingExcel] = useState(false);


    const onSKUCategoryChange = (e) => {
        let _selectedCategories = [...selectedTypesCategories];

        if (e.checked) _selectedCategories.push(e.value);
        else
            _selectedCategories = _selectedCategories.filter(
                (category) => category.key !== e.value.key
            );

        setSelectedTypesCategories(_selectedCategories);
    };
    const onGeogCategoryChange = (e) => {
        let _selectedCategories = [...selectedGeogCateg];

        if (e.checked) _selectedCategories.push(e.value);
        else
            _selectedCategories = _selectedCategories.filter(
                (category) => category.key !== e.value.key
            );

        setSelectedGeogCateg(_selectedCategories);
    };

    const onDistCategoryChange = (e) => {
        let _selectedCategories = [...selectedDistCateg];

        if (e.checked) _selectedCategories.push(e.value);
        else
            _selectedCategories = _selectedCategories.filter(
                (category) => category.key !== e.value.key
            );

        setSelectedDistCateg(_selectedCategories);
    };
    const onCustCategoryChange = (e) => {
        let _selectedCategories = [...selectedcustCateg];

        if (e.checked) _selectedCategories.push(e.value);
        else
            _selectedCategories = _selectedCategories.filter(
                (category) => category.key !== e.value.key
            );

        setSelectedcustCateg(_selectedCategories);
    };
    const onProdCategoryChange = (e) => {
        let _selectedCategories = [...selectedprodCateg];

        if (e.checked) _selectedCategories.push(e.value);
        else
            _selectedCategories = _selectedCategories.filter(
                (category) => category.key !== e.value.key
            );

        setSelectedprodCateg(_selectedCategories);
    };
    useEffect(() => {
        let dropdownurl = "SalesReport/GetdropDownValues?";
        const onpageLoad = async () => {
            try {
                const dropdownApi = `${dropdownurl}type=QUARTER`;
                let dataresponse = await Axios.get(dropdownApi);
                setFromDate(dataresponse.data);
                setSelectedFromDate(dataresponse.data[0]);
                setSelectedToDate(dataresponse.data[1]);
                setToDate(dataresponse.data);
            } catch (error) {
                console.log(error);
            }
        };
        onpageLoad();
    }, []);

    // console.log(format(new Date(), "yyyy"));
    // console.log(selectedFromDate);

    const handleExportdata = async () => {
        let payloaddata = {
            strSalesReturnId: "102",
            userId: auth.UserId,
            compId: auth.CompId,
            chkSalesManager: selectedDistCateg.some((item) => item.key === "SM")
                ? "Y"
                : "N",
            chkSalesExe: selectedDistCateg.some((item) => item.key === "SE")
                ? "Y"
                : "N",
            chkState: selectedGeogCateg.some((item) => item.key === "S") ? "Y" : "N",
            chkDistict: selectedGeogCateg.some((item) => item.key === "D")
                ? "Y"
                : "N",
            chkTown: selectedGeogCateg.some((item) => item.key === "T") ? "Y" : "N",
            chkMarket: selectedcustCateg.some((item) => item.key === "M") ? "Y" : "N",
            chkSector: selectedcustCateg.some((item) => item.key === "S") ? "Y" : "N",
            chkSubSector: selectedcustCateg.some((item) => item.key === "SS")
                ? "Y"
                : "N",
            chkSubSecdetails: selectedcustCateg.some((item) => item.key === "SSD")
                ? "Y"
                : "N",
            chkChannel: selectedcustCateg.some((item) => item.key === "CH")
                ? "Y"
                : "N",
            chkCustomer: selectedcustCateg.some((item) => item.key === "CU")
                ? "Y"
                : "N",
            // chkCustomer: selectedcustCateg.some((item) => item.key === "CU")
            //     ? "Y"
            //     : "N",
            chkMasterBrand: selectedprodCateg.some((item) => item.key === "MB")
                ? "Y"
                : "N",
            chkProductBrnd: selectedprodCateg.some((item) => item.key === "PB")
                ? "Y"
                : "N",
            chkPrdctBrndVarnt: selectedprodCateg.some((item) => item.key === "PBV")
                ? "Y"
                : "N",
            chkPrdctType: selectedprodCateg.some((item) => item.key === "PT")
                ? "Y"
                : "N",
            chkPrdtSubType: selectedprodCateg.some((item) => item.key === "PST")
                ? "Y"
                : "N",
            chkPrdtvarint: selectedprodCateg.some((item) => item.key === "PV")
                ? "Y"
                : "N",
            chkProduct: selectedprodCateg.some((item) => item.key === "PR")
                ? "Y"
                : "N",
            chkShowBasePack: selectedprodCateg.some((item) => item.key === "BP")
                ? "Y"
                : "N",
            chkProdAttr1: selectedprodCateg.some((item) => item.key === "MS")
                ? "Y"
                : "N",
            chkLBM: selectedprodCateg.some((item) => item.key === "LBMB") ? "Y" : "N",
            rbVertical: downloadformatCategory.key === "V" ? "Y" : "N",
            rbHorizontal: downloadformatCategory.key === "H" ? "Y" : "N",
            chkPack: selectedTypesCategories?.some((item) => item.key === "P")
                ? "Y"
                : "N",
            chkCase: selectedTypesCategories?.some((item) => item.key === "C")
                ? "Y"
                : "N",
            chkLtr: selectedTypesCategories?.some((item) => item.key === "L")
                ? "Y"
                : "N",
            chkProdValue: selectedTypesCategories?.some((item) => item.key === "PV")
                ? "Y"
                : "N",
            chkIncludeFree: freecategories?.key === "IF" ? "Y" : "N",
            chkShowOnlyFree: freecategories?.key === "SF" ? "Y" : "N",
            fromDate: format(new Date(fromyear), "yyyy"),
            toDate: format(new Date(toyear), "yyyy"),
            fromindexQtarweek: selectedFromDate.OBJ_ID,
            toindexQtarweek: selectedtoDate.OBJ_ID,
            chkYear: "",
        };
        try {
            setLoadingExcel(true);
            let salesrptURL =
        "SalesReport/SalesMonthlyPeriodicDailyWeeklyQuarterlyreport?";
            let dataresponse = await Axios.post(
                salesrptURL,
                JSON.stringify(payloaddata),
                {
                    headers: { "Content-Type": "application/json" },
                }
            );
            if (dataresponse?.data?.Data) {
                if (selectedfiletype.key == "xlsx") {
                    downloadExcel(
                        dataresponse?.data?.Data,
                        `SalesCastrolQuarterly${GetDateFormat()}.xlsx`
                    );
                } else {
                    downloadExcel(
                        dataresponse?.data?.Data,
                        `SalesCastrolQuarterly${GetDateFormat()}.csv`
                    );
                }
            } else if (dataresponse.data.Status == "warning") {
                toast.warning(`${dataresponse.data.Message}`, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingExcel(false);
        }
    };

    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Sales Castrol Quarterly</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="float-end mb-2">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleExportdata}
                                disabled={loadingExcel}
                            >
                                {loadingExcel ? "Loading..." : "Export"}{" "}
                                {loadingExcel ? (
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                ) : (
                                    <Fa.FaFileExport className="ms-2" />
                                )}
                            </button>
                        </div>
                    </div>
                </div>
                <section className="sales-box">
                    <form>
                        <div className="row">
                            <div className="col-lg-5 col-md-6 col-sm-12 mb-3">
                                <label className="form-label">From</label>
                                <div className="row">
                                    <div className="col-lg-5 col-md-12 col-sm-12 pe-0">
                                        <Dropdown
                                            value={selectedFromDate}
                                            onChange={(e) => {
                                                setSelectedFromDate(e.value);
                                            }}
                                            options={fromDate}
                                            optionLabel="OBJ_DESC"
                                        />
                                    </div>
                                    <div className="col-lg-7 col-md-12 col-sm-12">
                                        <Calendar
                                            view="year"
                                            value={fromyear}
                                            onChange={(e) => setFromYear(e.value)}
                                            dateFormat="yy"
                                            showIcon
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-6 col-sm-12 mb-3">
                                <label className="form-label">To</label>
                                <div className="row">
                                    <div className="col-lg-5 col-md-12 col-sm-12 pe-0">
                                        <Dropdown
                                            value={selectedtoDate}
                                            onChange={(e) => {
                                                setSelectedToDate(e.value);
                                            }}
                                            options={toDate}
                                            optionLabel="OBJ_DESC"
                                        />
                                    </div>
                                    <div className="col-lg-7 col-md-12 col-sm-12">
                                        <Calendar
                                            view="year"
                                            value={toyear}
                                            onChange={(e) => setToYear(e.value)}
                                            dateFormat="yy"
                                            showIcon
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-6 col-sm-12 mb-3">
                                <label className="form-label mb-2">Select File Type</label>
                                <Dropdown
                                    value={selectedfiletype}
                                    onChange={(e) => setSelectedfiletype(e.value)}
                                    options={downloadfiletypes}
                                    optionLabel="name"
                                    placeholder="File Type"
                                />
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <label className="form-label mb-2">Download Format</label>
                                <div className="flex d-flex flex-wrap gap-2">
                                    {downloadFormat.map((category) => {
                                        return (
                                            <div
                                                key={category.key}
                                                className="flex align-items-center"
                                            >
                                                <RadioButton
                                                    inputId={category.key}
                                                    name="category"
                                                    value={category}
                                                    onChange={(e) => setDownloadformatCategory(e.value)}
                                                    checked={downloadformatCategory.key === category.key}
                                                />
                                                <label htmlFor={category.key} className="ms-2">
                                                    {category.name}
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <label className="form-label mb-2">Select Type</label>
                                <div className="flex d-flex flex-wrap gap-2">
                                    {freecategory.map((category) => {
                                        return (
                                            <div
                                                key={category.key}
                                                className="flex align-items-center"
                                            >
                                                <RadioButton
                                                    inputId={category.key}
                                                    name="category"
                                                    value={category}
                                                    onChange={(e) => setFreecategories(e.value)}
                                                    checked={freecategories.key === category.key}
                                                />
                                                <label htmlFor={category.key} className="ms-1">
                                                    {category.name}
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-6 col-sm-12">
                                <div className="flex d-flex flex-wrap pt-4">
                                    {typecategories?.map((category) => {
                                        return (
                                            <div
                                                key={category.key}
                                                className="flex align-items-center mx-2"
                                            >
                                                <Checkbox
                                                    inputId={category.key}
                                                    name="category"
                                                    value={category}
                                                    onChange={onSKUCategoryChange}
                                                    checked={selectedTypesCategories.some(
                                                        (item) => item.key === category.key
                                                    )}
                                                />
                                                <label htmlFor={category.key} className="ms-1">
                                                    {category.name}
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
                <section className="GreyCheckBoxPanel">
                    <div className="col-lg-12 col-md-12 col-sm-12 mt-2">
                        <div className="rep-panel">
                            <h4>
                                <Fa.FaCubes className="iconP" /> Distributor
                            </h4>
                            <div className="CheckBoxPanel pt-1">
                                <div className="row">
                                    {distcategories?.map((category) => {
                                        return (
                                            <div
                                                key={category.key}
                                                className="col-lg-4 col-md-12 col-sm-12 mb-2"
                                            >
                                                <Checkbox
                                                    inputId={category.key}
                                                    name="category"
                                                    value={category}
                                                    onChange={onDistCategoryChange}
                                                    checked={selectedDistCateg.some(
                                                        (item) => item.key === category.key
                                                    )}
                                                />
                                                <label htmlFor={category.key} className="ms-1">
                                                    {category.name}
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="rep-panel">
                            <h4>
                                <Fa.FaGlobe className="iconP" /> Geography
                            </h4>
                            <div className="CheckBoxPanel pt-1">
                                <div className="row">
                                    {geographycategories?.map((category) => {
                                        return (
                                            <div
                                                key={category.key}
                                                className="col-lg-4 col-md-12 col-sm-12 mb-2"
                                            >
                                                <Checkbox
                                                    inputId={category.key}
                                                    name="category"
                                                    value={category}
                                                    onChange={onGeogCategoryChange}
                                                    checked={selectedGeogCateg.some(
                                                        (item) => item.key === category.key
                                                    )}
                                                />
                                                <label htmlFor={category.key} className="ms-1">
                                                    {category.name}
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="rep-panel">
                            <h4>
                                <Fa.FaUser className="iconP" /> Customer
                            </h4>
                            <div className="CheckBoxPanel pt-1">
                                <div className="row">
                                    {customercategories?.map((category) => {
                                        return (
                                            <div
                                                key={category.key}
                                                className="col-lg-4 col-md-12 col-sm-12 mb-2"
                                            >
                                                <Checkbox
                                                    inputId={category.key}
                                                    name="category"
                                                    value={category}
                                                    onChange={onCustCategoryChange}
                                                    checked={selectedcustCateg.some(
                                                        (item) => item.key === category.key
                                                    )}
                                                />
                                                <label htmlFor={category.key} className="ms-1">
                                                    {category.name}
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="rep-panel">
                            <h4>
                                <Fa.FaCube className="iconP" /> Product
                            </h4>
                            <div className="CheckBoxPanel pt-1">
                                <div className="row">
                                    {productcategories?.map((category) => {
                                        return (
                                            <div
                                                key={category.key}
                                                className="col-lg-4 col-md-12 col-sm-12 mb-2"
                                            >
                                                <Checkbox
                                                    inputId={category.key}
                                                    name="category"
                                                    value={category}
                                                    onChange={onProdCategoryChange}
                                                    checked={selectedprodCateg.some(
                                                        (item) => item.key === category.key
                                                    )}
                                                />
                                                <label htmlFor={category.key} className="ms-1">
                                                    {category.name}
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default SalesCastrolQuarterly;
